import { FormikProps } from "formik";
import React from "react";
import ATMTextField from "../UI/atoms/formFields/ATMTextField/ATMTextField";
import ATMLoadingButton from "../UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMFilePickerWrapper from "../UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";
import { VerificationInitialValues } from "./ReuploadAcknowledgementDialogWrapper";
import { getAcknowledgementNumber , isValidFileName  } from "src/utils/acknowledgementNumber/acknowledgementNumber";
import { showToast } from "src/utils/toaster/showToast";

type Props = {
  formikProps: FormikProps<VerificationInitialValues>;
  onClose: () => void;
  type:string
  catgory?:string
};

const ReuploadAcknowledgementDialog = ({ formikProps, onClose, type, catgory }: Props) => {
  const { values, setFieldValue, isSubmitting } = formikProps;

  return (
    <div className=" flex flex-col overflow-auto   rounded  bg-white relative ">
      <div className="grow overflow-auto">

      {
          type == 'PAN' && catgory ?

          <>
           {/*
             Name and father's name are not asked for here — they are typed on
             the PAN form, which is the reviewed source of truth, and the API
             mirrors them onto the application from there. Only the residence
             address is captured, because the DSA / PCO form has no residential
             block to read it off. Same rule as ApplicationVerifyDialog.
           */}

         {/* Residential address */}
         <div className="py-3 w-[90%]">
          <ATMTextField
            className=" py-5"
            name="acknowledgement_address"
            value={values.acknowledgement_address}
            onChange={(e) => {
              setFieldValue("acknowledgement_address", e.target.value);
            }}
            label="Residential address"
            placeholder="Residential address"
          />
        </div>

        {/* Place — captured alongside the address for the same reason: the
            DSA / PCO correction form has no residential block, and both the
            Affidavit and the Employer certificate print the Place. */}
        <div className="py-3 w-[90%]">
          <ATMTextField
            className=" py-5"
            name="acknowledgement_place"
            value={values.acknowledgement_place}
            onChange={(e) => {
              setFieldValue("acknowledgement_place", e.target.value);
            }}
            label="Place"
            placeholder="Place"
          />
        </div>
        </>:null
         }
        
        {/* Acknowledgement */}
        <div className="py-2 w-[90%]">
        <div className="py-2 w-[90%]">
          <ATMFilePickerWrapper
            name="acknowledgement"
            selectedFile={values.acknowledgement}
            accept="application/pdf"
            onSelect={(newValue: any) => {
             if(type === 'PAN'){
              if (isValidFileName(newValue.name)) {
                setFieldValue("acknowledgement", newValue);
                setFieldValue(
                  "acknowledgementNumber",
                  getAcknowledgementNumber(newValue.name)
                );
              } else {
                showToast("error", "Invalid File name");
                setFieldValue("acknowledgement", "");
              }
             }else{
              setFieldValue("acknowledgement", newValue);
              setFieldValue(
                "acknowledgementNumber",
                ''
              );
             }
            }}
            label="Acknowledgement"
            hideCloseButton
          />
        </div>
        </div>
        {/* Remark */}
        <div className="py-3 w-[90%]">
          <ATMTextField
            className=" py-5"
            name="remark"
            value={values.remark}
            onChange={(e) => {
              setFieldValue("remark", e.target.value);
            }}
            label="Remark"
            placeholder="Remark"
          />
        </div>
      </div>

      <div className="flex justify-end pt-3">
        <div className="flex justify-end gap-3">
          <ATMLoadingButton
            className="border-primary-main text-primary-main bg-white"
            onClick={onClose}
          >
            Cancel
          </ATMLoadingButton>

          <ATMLoadingButton
            type="submit"
            isLoading={isSubmitting}
            className="bg-primary-main"
          >
            Upload
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default ReuploadAcknowledgementDialog;
